import DataObject from "./DataObject";

export default class User extends DataObject {
    constructor(data) {
        super(data);
    }

    getCustomerSetting(key = null) {
        if (!key) {
            return null;
        }

        return this.getData("customer_settings").find(
            (setting) => setting.key == key
        );
    }

    getCurrentWeight() {
        return (this.getData("current_weight") || 0).toFixed(1);
    }

    getStartWeight() {
        return (this.getData("start_weight") || 0).toFixed(1);
    }

    isMember() {
        return Boolean(this.getData("member"));
    }
}
